import React, { StatelessComponent } from "react";

import { Text, TStyleTextColor } from "@/eworkitComponents";

interface IErrorFaceProps {
  color?: TStyleTextColor;
}
export const ErrorFace: StatelessComponent<IErrorFaceProps> = ({ color = "primary" }) => (
  <Text weight="bold" size="xl" color={color}>
    ʘ︵ʘ
  </Text>
);
